import React from 'react';
import { faDroplet } from '@fortawesome/free-solid-svg-icons';
import { WidgetRow, WidgetFooter, WidgetEmpty, Pill, Age, useGoTo } from './common';

const MyEnquiriesWidget = ({ data }) => {
  const goTo = useGoTo();
  const items = data.items || [];
  const groups = data.groups || [];
  return (
    <>
      {groups.length > 0 && (
        <div className="mydesk-groups">
          {groups.map((g) => (
            <span key={g.stage} className="mydesk-group">
              <strong>{g.count}</strong> {g.label}
            </span>
          ))}
        </div>
      )}
      {items.length === 0 && <WidgetEmpty>You have no open fuel enquiries.</WidgetEmpty>}
      {items.map((e) => (
        <WidgetRow
          key={e.id}
          icon={faDroplet}
          tone="brand"
          title={e.partner_name || e.number}
          subtitle={[e.number, e.product, e.port].filter(Boolean).join(' · ')}
          right={(
            <>
              {e.credit_label && <Pill tone={e.credit_tone || 'neutral'}>{e.credit_label}</Pill>}
              <Age>{e.stage_label}</Age>
            </>
          )}
          onClick={e.url ? () => goTo(e.url) : undefined}
        />
      ))}
      <WidgetFooter label="Open Trade Ops Bunkers" url={data.url} />
    </>
  );
};

export default MyEnquiriesWidget;
